const navegacionSigStore = {
    namespaced: true,
    state: () => ({
        objetosSig: [],
        posicion: {},
    }),
    mutations: {
        actualizarObjetosSig(state, payload) {
            state.objetosSig = payload;
        },
        actualizarPosicion(state, payload) {
            state.posicion = payload;
        },
    },

    getters: {
        obtenerElementos(state) {
            return state.aplicacionesCliente;
        }
    },
}

export default navegacionSigStore